/**
 * Flujo económico horizontal — nodos + conversiones.
 */
export default function EconomicFlow({ stages = [], conversions = [] }) {
  const convMap = {};
  (conversions || []).forEach((c) => {
    if (c && c.from && c.to) convMap[c.from + '>' + c.to] = c;
  });

  const visible = (stages || []).filter(Boolean);

  return (
    <div className="exec-flow" role="list" aria-label="Flujo económico">
      {visible.map((stage, idx) => {
        const next = visible[idx + 1];
        const bridge = next ? convMap[stage.id + '>' + next.id] : null;

        return (
          <div key={stage.id} className="exec-flow-item" role="listitem">
            <div
              className={
                'exec-flow-node' +
                (stage.status === 'unavailable' ? ' is-unavailable' : '') +
                (stage.status === 'available' ? ' is-available' : '')
              }
            >
              <p className="exec-flow-label">{stage.label}</p>
              <p className="exec-flow-value">
                {stage.status === 'unavailable' || stage.value == null
                  ? 'No disponible'
                  : formatValue(stage.value, stage.id)}
              </p>
              {stage.note ? <p className="exec-flow-note">{stage.note}</p> : null}
            </div>
            {idx < visible.length - 1 ? (
              <div className="exec-flow-edge" aria-hidden="true">
                <span className="exec-flow-arrow">↓</span>
                {bridge && bridge.rate != null ? (
                  <span className="exec-flow-conv">
                    {bridge.rate}%
                    {bridge.deltaPp != null ? (
                      <span
                        className={
                          'exec-flow-delta' +
                          (bridge.deltaPp < 0 ? ' is-down' : bridge.deltaPp > 0 ? ' is-up' : '')
                        }
                      >
                        {' '}
                        {bridge.deltaPp > 0 ? '+' : ''}
                        {bridge.deltaPp} pp
                      </span>
                    ) : null}
                  </span>
                ) : (
                  <span className="exec-flow-conv is-muted">—</span>
                )}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

function formatValue(v, id) {
  if (typeof v === 'number' && id === 'investment') {
    return '$' + Math.round(v).toLocaleString('es-CL', { maximumFractionDigits: 0 });
  }
  if (typeof v === 'number') {
    return v.toLocaleString('es-CL');
  }
  return String(v);
}
